[
    {
        "id": 10,
        "title": "Prove Humanity",
        "description": "add passkey, verify phone number...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 2
    },
    {
        "id": 20,
        "title": "Create Safes",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 2
    },
    {
        "id": 30,
        "title": "Mint B-Thank",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 1
    },
    {
        "id": 40,
        "title": "Mine B-Thank",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 50,
        "title": "Dear Miss Aquarius™ AI",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 60,
        "title": "Setup Notifications",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 70,
        "title": "Advanced Features",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 80,
        "title": "Use Cases",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 90,
        "title": "Accept Terms",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 100,
        "title": "Quiz",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 110,
        "title": "Say Hello on WhatsApp!",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    },
    {
        "id": 120,
        "title": "Order FREE Sample of B-Stamps",
        "description": "Do something...",
        "url": "https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1",
        "status": 0
    }
]
